import { render, staticRenderFns } from "./SubscriptionplanDetails.vue?vue&type=template&id=7270349d&scoped=true&"
import script from "./SubscriptionplanDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionplanDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionplanDetails.vue?vue&type=style&index=0&id=7270349d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270349d",
  null
  
)

export default component.exports